// extracted by mini-css-extract-plugin
export default {"box":"blogsFilterPage_box__7Xs7p","box__content__dropdown":"blogsFilterPage_box__content__dropdown__keg4u","box__btn":"blogsFilterPage_box__btn__GkY-i"};